<script setup>
import BlockContent from '../UI/Content/BlockContent.vue'

defineProps({
  salesmen: {
    type: Array,
    default: () => [],
  },
})
</script>

<template>
  <BlockContent
    :title-t="salesmen.length > 1 ? 'home.dashboardSalesman.multiple' : 'home.dashboardSalesman.title'"
    title-level="5"
    color="info"
    e2e-block="homeDashboardCompanySalesman"
  >
    <div class="mb-3" v-for="salesman in salesmen" :key="salesman.id">
      <div class="row">
        <div class="col-4">
          <strong>{{ $t('home.dashboardSalesman.name') }}</strong>
        </div>
        <div class="col-8">
          {{ salesman.name }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <strong>{{ $t('home.dashboardSalesman.phone') }}</strong>
        </div>
        <div class="col-8">
          {{ salesman.phone }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <strong>{{ $t('home.dashboardSalesman.email') }}</strong>
        </div>
        <div class="col-8">
          {{ salesman.email }}
        </div>
      </div>
    </div>
  </BlockContent>
</template>
